import DetailInput from './DetailInput';
import GeneralInput from './Generallnput';
import PlanTile from './PlanTile';

export { DetailInput, GeneralInput, PlanTile };
